<template>
  <!--Condition is added inorder to remove visibility of access page while direct by pass for 316 and extra health-->
  <div>
   <div v-if="isLandingDirectRedirection"></div>
    <div v-else>
      <access-page />
    </div>
  </div>
</template>

<script>
import AccessPage from "./AccessPage";
export default {
  name: "EmptyLoadingPage",
  components: {
    AccessPage
  },
  computed: {
    isLandingDirectRedirection() {
      return this.$store.getters.isLandingDirectRedirection
    }
  }
}
</script>

<style scoped></style>